import { Wrench, Clock } from "lucide-react";

export const Maintenance = ({ message }) => {
  return (
    <div
      className="relative flex min-h-screen items-center justify-center overflow-hidden"
      data-testid="maintenance-page"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1631896928983-2c94ea6f97e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxnYW1lJTIwY29udHJvbGxlciUyMG5lb24lMjBkYXJrfGVufDB8fHx8MTc5MjA1NDU0Nnww&ixlib=rb-4.1.0&q=85')",
        }}
      />
      <div className="absolute inset-0 bg-black/82" />
      <div className="relative z-10 mx-5 max-w-xl rk-glass rounded-3xl p-10 text-center rk-fade-up">
        <div className="mb-6 inline-grid h-16 w-16 place-items-center rounded-2xl bg-gradient-to-b from-[#ffd700] to-[#e5b80b] text-black rk-gold-glow">
          <Wrench size={28} strokeWidth={2.4} />
        </div>
        <h1 className="mb-3 text-4xl font-extrabold tracking-tight sm:text-5xl">
          Sedang <span className="text-[#e5b80b]">Dipelihara</span>
        </h1>
        <p className="mb-6 text-sm leading-relaxed text-zinc-300 sm:text-base">
          {message ||
            "Pemeliharaan rutin mingguan sedang berjalan. Kami membersihkan cache, mengoptimalkan database, dan membereskan transaksi lama."}
        </p>
        <div className="mx-auto mb-6 h-px w-24 bg-gradient-to-r from-transparent via-[#e5b80b]/60 to-transparent" />
        <div className="flex items-center justify-center gap-2 text-sm text-[#e5b80b]">
          <Clock size={16} />
          <span>
            Setiap Kamis · 05:00 – 06:00 WIB · Website akan otomatis kembali
            online
          </span>
        </div>
      </div>
    </div>
  );
};
